import React, { useState, useEffect, useRef, useCallback } from 'react';
import { AuthProvider, useAuth } from './components/AuthProvider.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';
// Restored to core CRM functionality (V33 Checkpoint)
import AppContent from './AppContent.tsx';
import type { Page, OmniSearchResultItem, AuthenticatedUser } from './types.ts';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes default
      retry: 1,
    },
  },
});

const App: React.FC = () => {

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
